// src/views/OrderRegistration.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const OrderRegistration = () => {
    const cart = [
    { name: "Classic Blue Jeans", quantity: 2, price: 59.99 },
    { name: "Summer Breeze T-Shirt", quantity: 3, price: 24.99 },
    ];

    const envio = 5.0;
    const subtotal = cart.reduce((acc, item) => acc + item.quantity * item.price, 0);
    const total = subtotal + envio;

  const [customer, setCustomer] = useState({
    name: "",
    address: "",
    contact: "",
  });

  const [paymentMethod, setPaymentMethod] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Datos simulados de carrito (luego deberías traerlos del contexto o redux)
    const cart = [
      { name: "Classic Blue Jeans", quantity: 2, price: 59.99 },
      { name: "Summer Breeze T-Shirt", quantity: 3, price: 24.99 },
    ];

    const subtotal = cart.reduce(
      (acc, item) => acc + item.quantity * item.price,
      0
    );

    const envio = 5.0;
    const total = subtotal + envio;

    // Redirige a confirmación pasando datos
    navigate("/pago-inicial", {
      state: {
        customer,
        paymentMethod,
        cart,
        subtotal,
        envio,
        total,
      },
    });
  };

  return (
    <div
      className="relative flex size-full min-h-screen flex-col bg-white overflow-x-hidden"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div className="layout-container flex h-full grow flex-col">

        {/* Contenido */}
        <div className="px-6 md:px-40 flex flex-1 justify-center py-5">
          <form
            onSubmit={handleSubmit}
            className="flex flex-col w-full md:w-[512px] py-5 max-w-[960px] flex-1"
          >
            <div className="flex flex-wrap justify-between gap-3 p-4">
              <p className="text-[#181111] text-[32px] font-bold">
                Confirmación del pedido
              </p>
            </div>

            {/* Datos del cliente */}
            <h3 className="text-[#181111] text-lg font-bold px-4 pb-2 pt-4">
              Datos del cliente
            </h3>
            <div className="flex flex-wrap gap-4 px-4 py-3">
              <label className="flex flex-col flex-1">
                <p className="text-[#181111] text-base font-medium pb-2">
                  Nombre
                </p>
                <input
                  type="text"
                  name="name"
                  value={customer.name}
                  onChange={handleChange}
                  placeholder="Ingrese el nombre"
                  className="form-input rounded-lg border border-[#e5dcdc] h-14 p-3"
                  required
                />
              </label>
            </div>
            <div className="flex flex-wrap gap-4 px-4 py-3">
              <label className="flex flex-col flex-1">
                <p className="text-[#181111] text-base font-medium pb-2">
                  Dirección
                </p>
                <input
                  type="text"
                  name="address"
                  value={customer.address}
                  onChange={handleChange}
                  placeholder="Ingrese la dirección"
                  className="form-input rounded-lg border border-[#e5dcdc] h-14 p-3"
                  required
                />
              </label>
            </div>
            <div className="flex flex-wrap gap-4 px-4 py-3">
              <label className="flex flex-col flex-1">
                <p className="text-[#181111] text-base font-medium pb-2">
                  Contacto (WhatsApp o teléfono)
                </p>
                <input
                  type="text"
                  name="contact"
                  value={customer.contact}
                  onChange={handleChange}
                  placeholder="Ingrese contacto"
                  className="form-input rounded-lg border border-[#e5dcdc] h-14 p-3"
                  required
                />
              </label>
            </div>

            {/* Método de pago */}
            <h3 className="text-[#181111] text-lg font-bold px-4 pb-2 pt-4">
              Método de pago
            </h3>
            <div className="flex flex-wrap gap-3 p-4">
              {["Yape", "Transferencia"].map((method) => (
                <label
                  key={method}
                  className={`cursor-pointer border rounded-lg px-4 h-11 flex items-center ${
                    paymentMethod === method
                      ? "border-2 border-red-600"
                      : "border-[#e5dcdc]"
                  }`}
                >
                  <input
                    type="radio"
                    name="payment"
                    value={method}
                    checked={paymentMethod === method}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    className="hidden"
                  />
                  {method}
                </label>
              ))}
            </div>

            {/* Resumen */}
            <h3 className="text-[#181111] text-lg font-bold px-4 pb-2 pt-4">
              Resumen del pedido
            </h3>
            <div className="p-4">
              {[
                ...[
                  { label: "Productos", items: cart.map((i) => i) },
                ],
              ].map((section, idx) => (
                <div key={idx}>
                  {section.items.map((item) => (
                    <div
                      key={item.name}
                      className="flex justify-between py-2 text-sm text-gray-600"
                    >
                      <p>
                        {item.quantity} x {item.name}
                      </p>
                      <p>${(item.quantity * item.price).toFixed(2)}</p>
                    </div>
                  ))}
                </div>
              ))}
              <div className="flex justify-between py-2">
                <p className="text-sm text-gray-600">Envío</p>
                <p className="text-sm">${envio.toFixed(2)}</p>
              </div>
              <div className="flex justify-between py-2 font-bold">
                <p className="text-sm">Total</p>
                <p className="text-sm">${total.toFixed(2)}</p>
              </div>
            </div>

            {/* Botón */}
            <div className="flex px-4 py-3">
              <button
                type="submit"
                className="flex flex-1 justify-center items-center rounded-lg h-12 px-5 bg-red-600 text-white font-bold hover:bg-red-700"
              >
                Confirmar pedido
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OrderRegistration;
